import React from 'react'
import MaterialSymbol from '../material-symbol'

const TrendingUp = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="trending_up" {...props} />
))

TrendingUp.displayName = 'TrendingUp'

export default TrendingUp
